import { render } from "./IndexPaiement.vue?vue&type=template&id=143cadf4"
import script from "./IndexPaiement.vue?vue&type=script&lang=js"
export * from "./IndexPaiement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__